"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { classNames, FlexCenter, FlexColumn, Media } from "@opensea/ui-kit";
import { useCollectionLayout } from "@/components/collection/CollectionLayoutProvider";
import { useHeroHeaderView } from "@/components/hero-header/HeroHeaderViewProvider";
import { useIsCollectionOverviewOnlyEnabled } from "@/hooks/use-flags";
import { HeroHeaderViewToggle } from "../../hero-header/HeroHeaderViewToggle";
import { CollectionStats } from "../CollectionStats/CollectionStats";
import { CollectionStatsFragment } from "../CollectionStats/CollectionStats.fragment";
export const CollectionHeaderStatsFragment = graphql(`
    fragment CollectionHeaderStats on Collection {
      slug
      ...CollectionStats
    }
  `, [CollectionStatsFragment]);
export function CollectionHeaderStats(t0) {
  const $ = _c(15);
  const {
    collection: collectionKey
  } = t0;
  const {
    headerView
  } = useHeroHeaderView();
  const {
    isPreview
  } = useCollectionLayout();
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(CollectionHeaderStatsFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const isCollectionOverviewOnlyEnabled = useIsCollectionOverviewOnlyEnabled(collection.slug);
  let T0;
  let t2;
  let t3;
  if ($[2] !== collection || $[3] !== headerView || $[4] !== isCollectionOverviewOnlyEnabled) {
    const fullHiddenClassNames = classNames("w-0 !opacity-0", "-mr-2.5 sm:-mr-6 md:-mr-8");
    T0 = FlexCenter;
    t2 = "overflow-hidden md:gap-8 lg:justify-end";
    t3 = isCollectionOverviewOnlyEnabled ? null : <><Media greaterThanOrEqual="md"><CollectionStats className="w-full justify-between md:w-auto" collection={collection} overrides={{
          "24h_volume": {
            className: classNames(fullHiddenClassNames, headerView === "compact" && "xl:mr-auto xl:w-auto xl:!opacity-100")
          },
          "1d_floor_pcnt": {
            className: classNames(fullHiddenClassNames, headerView === "compact" && "xl:mr-auto xl:w-auto xl:!opacity-100")
          },
          listed: {
            className: "hidden md:flex lg:hidden 3xl:flex"
          },
          unique_owners: {
            className: "hidden md:flex lg:hidden 2xl:flex"
          }
        }} size={headerView === "full" ? "md" : "sm"} stats={["floor_price", "1d_floor_pcnt", "top_offer", "24h_volume", "total_volume", "listed", "unique_owners"]} /></Media><Media lessThan="md"><FlexColumn className="w-full gap-3"><CollectionStats className="w-full justify-between md:w-auto" collection={collection} overrides={{
            all: {
              className: "w-30"
            }
          }} stats={["floor_price", "1d_floor_pcnt", "top_offer"]} /><CollectionStats className="w-full justify-between md:w-auto" collection={collection} overrides={{
            all: {
              className: "w-30"
            }
          }} stats={["24h_volume", "total_volume", "unique_owners"]} /></FlexColumn></Media></>;
    $[2] = collection;
    $[3] = headerView;
    $[4] = isCollectionOverviewOnlyEnabled;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isPreview) {
    t4 = !isPreview && <HeroHeaderViewToggle />;
    $[8] = isPreview;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== T0 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <T0 className={t2}>{t3}{t4}</T0>;
    $[10] = T0;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}